import Vue from 'vue';
import Vuex from 'vuex';

import gaClient from './libs/ga';
import partnerAccess from './libs/partnerAccess';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogin: false,
    isGuest: false,
    profile: {
      userId: '',
      lineId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: '',
      partnerList: {},
      alertPartnerLink: '',
      partnerUpperLimit: 0,
    },
    currentUserId: '', // 現在選択しているuserId
    isSelectWithPartner: false, // 選択しているuserIdがパートナーと連携しているuserIdかどうか
    selectUsers: [], // 選択可能なユーザ（自分のみも含め）の一覧
    partners: [], // 連携中のパートナーのprofile
    snackbar: {
      isShow: false,
      color: '',
      text: '',
      type: '',
      timeout: 0,
    },
    errorCount: 0,
    memories: [],
    reloadMemories: false,
    transitionMode: 'fade',
  },
  mutations: {
    updateLogin(state, val) {
      state.isLogin = val;
      state.isGuest = !val;
    },
    updateLP(state) {
      state.isLogin = false;
      state.isGuest = false;
    },
    updateCurrentUserId(state, userId) {
      state.currentUserId = userId;
      state.isSelectWithPartner = userId !== state.profile.userId;
    },
    updateProfile(state, profile) {
      state.profile = JSON.parse(JSON.stringify(profile));

      if (!state.profile.pictureUrl) {
        state.profile.pictureUrl = '/free_user.png';
      }
    },
    updateAlertPartnerLink(state, value) {
      state.profile.alertPartnerLink = value;
    },
    updatePartners(state, partners) {
      state.partners = JSON.parse(JSON.stringify(partners));
    },
    updateSelectUsers(state) {
      state.selectUsers = partnerAccess.setSelectUsers(state.profile, state.partners);
      state.currentUserId = partnerAccess.getCurrentUserId(state.profile);
      state.isSelectWithPartner = state.currentUserId !== state.profile.userId;
    },
    updateMemories(state, memories) {
      state.memories = JSON.parse(JSON.stringify(memories));
    },
    reloadMemories(state) {
      state.reloadMemories = !state.reloadMemories;
    },
    updateMemory(state, memory) {
      const memories = state.memories[memory.prefecture - 1];
      memories.filter(m => m.id === memory.id)[0] = JSON.parse(JSON.stringify(memory));
    },
    deleteMemory(state, memory) {
      const memories = state.memories[memory.prefecture - 1];
      memories.forEach((m, index) => {
        if (m.id === memory.id) memories.splice(index, 1);
      });
    },
    updateSnackbar(state, val) {
      state.snackbar = val;
    },
    closeSnackbar(state) {
      state.snackbar.isShow = false;
    },
    changeTransitionMode(state, mode) {
      state.transitionMode = mode;
    },
  },
  actions: {
    initialLoginState({ commit }, val) {
      if (!/tripholders-token=/g.test(document.cookie)) {
        location.href = '/';
      }
      commit('updateLogin', val);
    },
    showSnackbar({ commit }, val) {
      gaClient.snackbar.alert(val.ga, val.snackbar);

      if (val.snackbar.color === 'error' && val.snackbar.text === this.state.snackbar.text) this.state.errorCount += 1;
      else this.state.errorCount = 0;

      if (!val.snackbar.timeout) val.snackbar.timeout = 5000;
      if (!val.snackbar.type) val.snackbar.type = 'close';

      val.snackbar.isShow = true;

      if (this.state.errorCount <= 2) commit('updateSnackbar', val.snackbar);
    },
  },
});
